module.exports = __webpack_public_path__ + "assets/media/categories-about.3661e74a.svg";